module.exports = __webpack_public_path__ + "img/openMap.b0bd5c36.svg";